import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        moreBtn: "read more",
        contact: {
          title: "let's get in touch",
          form: {
            title: "message",
            name: "Your name",
            email: "Your email",
            subject: "Subject",
            message: "Your message",
            submit: "submit",
          },
          info: {
            title: "our contact",
            email: "email address",
            callUsBtn: "call us",
            media: "social media",
          },
          location: {
            title: "location",
            address: "Koropi, Greece 19400",
          },
        },
        reporting: {
          eyebrow: "reporting channel",
          title: "secure reporting channel",
          description:
            "Our Reporting Channel provides a safe, confidential, and independent way to submit concerns, misconduct, or violations. You can submit a report anonymously or with your name—whichever you feel most comfortable with.",
          button: "submit your report",
          anonymousTitle: "anonymous or named",
          anonymousDescription:
            "Choose to remain anonymous or submit your report with your name.",
          confidentialTitle: "confidential process",
          confidentialDescription:
            "All reports are handled with the highest level of confidentiality and care.",
          independentTitle: "independent reporting portal",
          independentDescription:
            "Our reporting portal is managed independently and is separate from standard contact requests.",
          separateTitle: "separate and independent",
          separatePortal:
            "This reporting portal is completely separate from our standard contact forms and is managed by an independent system to ensure the integrity and confidentiality of your report.",
          voiceTitle: "your voice matters",
          voiceDescription:
            "We are committed to maintaining a culture of integrity, transparency, and accountability. Thank you for helping us uphold these values.",
        },
        footer: {
          title: "privacy policy",
          qualityPolicy: "Quality Policy",
          compliancePolicy: "Compliance Policy",
          ITServicesManagementPolicy: "IT Services Management Policy",
          environmentalPolicy: "Environmental Policy",
          healthAndSafetyPolicyAtWork: "Ηealth And Safety Policy At Work",
          antiBriberyPolicy: "Anti-Bribery Policy",
          violenceAndHarassmentPolicy: "Violence and Harassment Prevention Policy",
          recordManagementPolicy: "Record Management Policy",
          businessContinuityPolicy: "Βusiness Continuity Policy",
          informationSecurityPolicy: "Ιnformation Security Policy",
          personalDataSecurityPolicy: "Personal Data Security Policy",
          informationSystemsAcceptableUsePolicy:
            "Information Systems Acceptable Use Policy",
          energyPolicy: "Energy Policy",
          gemi: "GEMI Public Records",
          aang: "Member of",
          description:
            "Anyone who is interested in being informed about the Business Continuity Policy, Quality Policy, Safety & Health Policy, Environmental Policy, Records Management Policy, Anti-Bribery Policy, Personal Data Security Policy, according to ISO Certifications can contact us any time at",
        },
        home: {
          quote: `The Records Hub S.A., a member of the AAnG Holdings group, is active in the field of Secure Storage, Digitization, Destruction of Documents, Management of Records, Cybersecurity, Information Management & General Data Protection (GDPR) Compliance and Data Protection Officer (DPO) Services. The Records Hub ensures that its customers are provided secured tailor-made quality solutions, intended to their sustainable operation and growth, as they align their operations to current and future requirements. During internal inspections and risk assessments, The Records Hub provides for and indicates solutions to cover against any weaknesses or risks that may appear, to eliminate gaps and provide the maximum possible security in information management. The aim is to protect customer prestige and achieve a competitive advantage for the customer, in combination with considerable economic benefit. \n
            The Records Hub S.A. a member of the AAnG Holdings group, procedures provide optimum control which eliminates\noperational risk. At The Records Hub S.A. we can boast zero mishaps.`,
          aboutUsBtn: "about us",
          ourServicesBtn: "our services",
          aboutUsSession: {
            title: "About the company",
            content: `THE RECORDS HUB S.A. a member of the AAnG Holdings group, is a company with a portfolio of solutions including Secure Storage, Digitization, Destruction of Documents, Management of Records, Cybersecurity, Information Management & General Data Protection (GDPR) Compliance and Data Protection Officer (DPO) services.
                            THE RECORDS HUB S.A. ensures that its customers are provided secured tailor-made quality solutions, intended to their sustainable operation and growth, as they align their operations to current and future requirements. During internal inspections and risk assessments, THE RECORDS HUB S.A. provides for and indicates solutions to cover against any weaknesses or risks that may appear, in order to eliminate gaps and provide the maximum possible security in information management, in a timely and valid manner, both in ex ante control, but also in ex post intervention for all procedures. Our aim is to protect customer prestige and achieve a competitive advantage for the customer, in combination with considerable economic benefit.
                        `,
            contactUsBtn: "contact us",
            callUsBtn: "call us",
          },
          certsSession: {
            title: "Our Certifications",
          },
          servicesSession: {
            title: "Our Services",
          },
          reportsSession: {
            title: "ESG Reports",
          },
          ourGoalSession: {
            title: "Our goal is to help your business involve",
            description:
              "The secured management of the documents is the pillar for the digital transformation of every Private, Public and Non-Corporate Organization.",
          },
        },
        aboutUs: {
          title: "about us",
          quote:
            "Preserving the past... Protecting the present... Preparing the future...",
          numberLabel: {
            clients: "clients",
            projects: "projects",
            onGoingProjects: "on going projects",
          },
          statsSession: {
            title: "Preparing the future...",
            subtitle:
              "We have set the highest standards for the quality of services we provide and how we operate as a business.",
            description: `Since 2007, we have set the highest standards for the quality of services we provide and how we operate as a business. Our team, is focused in the complete facilitation of the customer's needs, by covering all the relevant to our lines of expertise requirements.
                            THE RECORDS HUB S.A. ensures that its customers are provided secured tailor-made quality solutions and intended to their sustainable operation and growth, as they align their operations to current and future requirements.
                            During internal inspections and risk assessments, THE RECORDS HUB S.A. provides for and indicates solutions to cover against any weaknesses or risks that may appear, in order to eliminate gaps and provide the maximum possible security in information management, in a timely and valid manner, both in ex ante control, but also in ex post intervention for all procedures. Our aim is to protect customer prestige and achieve a competitive advantage for the customer, in combination with considerable economic benefit.`,
            bar0Label: "secure storage services",
            bar1Label: "secure digitalization of physical documents",
            bar2Label: "secure documents management",
            bar3Label: "secure destruction",
          },
          contactUsBtn: "contact us",
          servicesSession: {
            title: "Top services",
            subtitle: "SECURE STORAGE SERVICES",
            li0: "Offsite physical document and file storage",
            li1: "Storage of records in a climate-controlled environment",
            li2: "Organization or records in a controlled inventory",
          },
          ourServicesBtn: "our services",
        },
        services: {
          title: "our services",
        },
        gdpr: {
          title: "information managment & general data protecion compiance",
          session0: {
            title: "What does it mean for your business?",
            description:
              "The GDPR applies to any organization inside or outside the European Union who is offering goods or services to, and/or tracking the behaviors of EU citizens. That means that if you do business with Europeans that involves the processing of their personal data, this legislation applies to you.",
          },
          session1: {
            title: "Key Challenges",
            description:
              "The new regulation impacts businesses in many ways. Privacy and data protection will be part of a company's core requirements leading the way in data collection and storage. All organisations should properly prepare and comply with the new policies, otherwise they can be fined. It is important to note that these rules apply to both data controllers and processors.",
          },
          servicesTitle:
            "The Records Hub S.A. provides you customized compliance, implementation, training and support services which are covering all GDPR.",
        },
        ourProjects: {
          title: "Our Projects",
          numberLabel0: "projects complete",
          numberLabel1: "clients",
        },
        contactUs: {
          title: "Contact Us",
        },
        cookies: {
          description:
            "This website only stores the necessary cookies to ensure its proper operation. We do not collect personal information, ensuring your privacy",
          closeBtn: "OK",
        },
      },
    },
    el: {
      translation: {
        moreBtn: "διαβαστε περισσοτερα",
        contact: {
          title: "επικοινωνηστε μαζι μας",
          form: {
            title: "μηνυμα",
            name: "Το Ονοματεπώνυμό σας:",
            email: "Το e-mail σας:",
            subject: "Θέμα:",
            message: "Το μήνυμά σας:",
            submit: "υποβολη",
          },
          info: {
            title: "στοιχεια επικοινωνίας",
            email: "email",
            callUsBtn: "καλέστε μας",
            media: "social media",
          },
          location: {
            title: "τοποθεσία",
            address: "Κορωπί, Ελλάδα 19400",
          },
        },
        reporting: {
          eyebrow: "ΚΑΝΑΛΙ ΑΝΑΦΟΡΩΝ",
          title: "ΑΣΦΑΛΕΣ ΚΑΝΑΛΙ ΑΝΑΦΟΡΩΝ",
          description:
            "Το Κανάλι Αναφορών παρέχει έναν ασφαλή, εμπιστευτικό και ανεξάρτητο τρόπο υποβολής αναφορών για περιστατικά, παραπτώματα ή παραβιάσεις. Μπορείτε να υποβάλετε την αναφορά σας ανώνυμα ή επώνυμα, επιλέγοντας τον τρόπο που σας κάνει να αισθάνεστε πιο άνετα.",
          button: "ΥΠΟΒΟΛΗ ΑΝΑΦΟΡΑΣ",
          anonymousTitle: "ΑΝΩΝΥΜΗ Η ΕΠΩΝΥΜΗ ΑΝΑΦΟΡΑ",
          anonymousDescription:
            "Επιλέξτε αν θέλετε να διατηρήσετε την ανωνυμία σας ή να υποβάλετε επώνυμη αναφορά.",
          confidentialTitle: "ΕΜΠΙΣΤΕΥΤΙΚΗ ΔΙΑΧΕΙΡΙΣΗ",
          confidentialDescription:
            "Όλες οι αναφορές εξετάζονται με απόλυτη εμπιστευτικότητα, υπευθυνότητα και τη δέουσα προσοχή.",
          independentTitle: "ΑΝΕΞΑΡΤΗΤΗ ΠΛΑΤΦΟΡΜΑ ΑΝΑΦΟΡΩΝ",
          independentDescription:
            "Η πλατφόρμα αναφορών λειτουργεί ανεξάρτητα και είναι πλήρως διαχωρισμένη από τα συνήθη αιτήματα επικοινωνίας.",
          separateTitle: "ΞΕΧΩΡΙΣΤΗ ΚΑΙ ΑΝΕΞΑΡΤΗΤΗ ΠΛΑΤΦΟΡΜΑ",
          separatePortal:
            "Η πλατφόρμα λειτουργεί ανεξάρτητα και είναι πλήρως διαχωρισμένη από τις συνήθεις φόρμες επικοινωνίας της εταιρείας. Με αυτόν τον τρόπο διασφαλίζονται η ακεραιότητα της διαδικασίας και η εμπιστευτικότητα κάθε αναφοράς.",
          voiceTitle: "Η ΦΩΝΗ ΣΑΣ ΕΧΕΙ ΣΗΜΑΣΙΑ",
          voiceDescription:
            "Δεσμευόμαστε να καλλιεργούμε μια κουλτούρα ακεραιότητας, διαφάνειας και λογοδοσίας. Σας ευχαριστούμε που συμβάλλετε στη διαφύλαξη αυτών των αξιών.",
        },
        footer: {
          title: "πολιτική απορρήτου",
          qualityPolicy: "Πολιτική ποιότητας",
          compliancePolicy: "Πολιτική συμμόρφωσης",
          ITServicesManagementPolicy:
            "Πολιτική Διαχείρισης Υπηρεσιών Πληροφορικής",
          environmentalPolicy: "Περιβαλλοντική Πολιτική",
          healthAndSafetyPolicyAtWork:
            "Πολιτική Υγείας και Ασφάλειας στην Εργασία",
          antiBriberyPolicy: "Πολιτική για την καταπολέμηση της Δωροδοκίας",
          violenceAndHarassmentPolicy: "Πολιτική Καταπολέμησης Βίας και Παρενόχλησης",
          recordManagementPolicy: "Πολιτική Διαχείρισης Αρχείων",
          businessContinuityPolicy: "Πολιτική Επιχειρησιακής Συνέχειας",
          informationSecurityPolicy: "Πολιτική Ασφάλειας Πληροφοριών",
          personalDataSecurityPolicy: "Πολιτική Ασφάλειας Προσωπικών Δεδομένων",
          informationSystemsAcceptableUsePolicy:
            "Πολιτική Αποδεκτής Χρήσης Πληροφοριακών Συστημάτων",
          energyPolicy: "Ενεργειακή Πολιτική",
          gemi: "Δημοσιότητα ΓΕΜΗ",
          aang: "Μέλος της",
          description:
            "Η Πολιτική Επιχειρησιακής Συνέχειας, Πολιτική Προστασίας, Πολιτική Ασφάλειας & Υγείας, Πολιτική Περιβάλλοντος, Πολιτική Διαχείρισης Αρχείων, Πολιτική, κατά της Δωροδοκίας, Πολιτική Ασφάλειας Προσωπικών Δεδομένων, σύμφωνα με τα πρότυπα ISO, βρίσκονται στην εταιρεία μας και όποιος ενδιαφέρεται μπορεί να απυθυνθεί στο",
        },
        home: {
          quote: `Η The Records Hub A.Ε., μέλος του ομίλου AAnG Holdings, δραστηριοποιείται στο χώρο των υπηρεσιών Ασφαλούς Φύλαξης Αρχείων, Ψηφιοποίησης Αρχείων, Καταστροφής Αρχείων, Διαχείρισης Αρχείων, Κυβερνοασφάλειας, Διαχείρισης πληροφοριών & συμμόρφωσης GDPR και Υπηρεσίες Υπεύθυνου Προστασίας Δεδομένων. Η The Records Hub διασφαλίζει την παροχή εξειδικευμένων και ασφαλών ποιοτικών λύσεων στους πελάτες της, στοχεύοντας στη βιώσιμη λειτουργία και ανάπτυξη τους, συμμορφώνοντας τις λειτουργίες τους στις παρούσες και μελλοντικές απαιτήσεις. Κατά τη διάρκεια των εσωτερικών ελέγχων και της εκτίμησης κινδύνου, η The Records Hub παρέχει λύσεις καλύπτοντας κάθε ρίσκο και αδυναμία που μπορεί να προκύψει, με σκοπό να εξαλείψει τα κενά και να παρέχει τη μέγιστη δυνατή ασφάλεια στη διαχείριση των πληροφοριών, έγκαιρα και έγκυρα. Στόχος είναι να προστατεύσει το κύρος των πελατών της και να επιτύχει ένα ανταγωνιστικό πλεονέκτημα για τον πελάτη, σε συνδυασμό με σημαντικό οικονομικό όφελος.\n
            Η The Records Hub S.A. μέλος του ομίλου AAnG Holdings, σας παρέχει τον απόλυτο έλεγχο εξαλείφοντας το\nλειτουργικό ρίσκο. Στην The Records Hub S.A. έχουμε μηδενικό περιθώριο\nλάθους.`,
          aboutUsBtn: "σχετικα με εμας",
          ourServicesBtn: "οι υπηρεσιες μας",
          aboutUsSession: {
            title: "Σχετικα με εμας",
            content: `Η THE RECORDSHUB S.A. μέλος του ομίλου AAnG Holdings, είναι μια εταιρεία με ευρύ χαρτοφυλάκιο λύσεων στο οποίο συμπεριλαμβάνονται υπηρεσίες Ασφαλούς Φύλαξης Αρχείων, Ψηφιοποίησης Αρχείων, Καταστροφής Αρχείων, Διαχείρισης Αρχείων, Κυβερνοασφάλειας, Διαχείρισης πληροφοριών & συμμόρφωσης GDPR και Υπηρεσίες Υπεύθυνου Προστασίας Δεδομένων.
                            Η THE RECORDS HUB S.A. διασφαλίζει την παροχή εξειδικευμένων και ασφαλών ποιοτικών λύσεων στους πελάτες της, στοχεύοντας στη βιώσιμη λειτουργία και ανάπτυξη τους, συμμορφώνοντας τις λειτουργίες τους στις παρούσες και μελλοντικές απαιτήσεις. Κατά τη διάρκεια των εσωτερικών ελέγχων και της εκτίμησης κινδύνου, η THE RECORDS HUB S.A. παρέχει και υποδεικνύει λύσεις καλύπτοντας κάθε ρίσκο και αδυναμία που μπορεί να προκύψει, με σκοπό να εξαλείψει τα κενά και να παρέχει τη μέγιστη δυνατή ασφάλεια στη διαχείριση των πληροφοριών, έγκαιρα και έγκυρα τόσο στον εκ των προτέρων έλεγχο, όσο και στην εκ των υστέρων παρέμβαση σε όλες τις διαδικασίες. Στόχος μας είναι να προστατεύσουμε το κύρος των πελατών μας και να επιτύχουμε ένα ανταγωνιστικό πλεονέκτημα για τον πελάτη, σε συνδυασμό με σημαντικό οικονομικό όφελος.
                        `,
            contactUsBtn: "επικοινωνηστε μαζι μας",
            callUsBtn: "καλεστε μας",
          },
          certsSession: {
            title: "Οι Πιστοποιήσεις μας",
          },
          servicesSession: {
            title: "Οι Υπηρεσίες μας",
          },
          reportsSession: {
            title: "ESG Αναφορές",
          },
          ourGoalSession: {
            title:
              "Στόχος μας είναι να βοηθήσουμε την επιχείρηση σας να εξελιχθεί.",
            description:
              "Η ασφαλής διαχείριση των αρχείων σας αποτελεί τον πυλώνα για τον ψηφιακό μετασχηματισμό κάθε Οργανισμού, Επιχείρησης και Κρατικής Δομής.",
          },
        },
        aboutUs: {
          title: "σχετικά με εμάς",
          quote:
            "Preserving the past... Protecting the present... Preparing the future...",
          numberLabel: {
            clients: "πελατεσ",
            projects: "εργα",
            onGoingProjects: "τρεχοντα εργα",
          },
          statsSession: {
            title: "Preparing the future...",
            subtitle:
              "Έχουμε θέσει τις υψηλότερες προδιαγραφές για την ποιότητα των υπηρεσιών που προσφέρουμε και τον τρόπο λειτουργίας της εταιρείας μας.",
            description: `Από το 2007, έχουμε θέσει τις υψηλότερες προδιαγραφές για την ποιότητα των υπηρεσιών που προσφέρουμε και τον τρόπο λειτουργίας της εταιρείας μας. Η ομάδα μας, είναι προσανατολισμένη στην πλήρη κατανόηση των αναγκών των πελατών της, καλύπτοντας όλα τα σχετικά κριτήρια με την εξειδίκευση μας.
                            Η THE RECORDS HUB S.A. διασφαλίζει ότι παρέχει στους πελάτες της εξειδικευμένες και ασφαλείς ποιοτικές λύσεις, στοχεύοντας στην βιώσιμη λειτουργία και ανάπτυξη τους, ευθυγραμμίζοντας τις λειτουργίες τους με τις τρέχουσες και μελλοντικές απαιτήσεις.
                            Κατά τη διάρκεια των εσωτερικών ελέγχων και της εκτίμησης κινδύνου, η THE RECORDS HUB S.A. παρέχει και υποδεικνύει λύσεις καλύπτοντας κάθε ρίσκο και αδυναμία που μπορεί να προκύψει, με σκοπό να εξαλείψει τα κενά και να παρέχει τη μέγιστη δυνατή ασφάλεια στη διαχείριση των πληροφοριών, έγκαιρα και έγκυρα τόσο στον εκ των προτέρων έλεγχο, όσο και στην εκ των υστέρων παρέμβαση σε όλες τις  διαδικασίες. Στόχος μας είναι να προστατεύσουμε το κύρος των πελατών μας και να επιτύχουμε ένα ανταγωνιστικό πλεονέκτημα για τον πελάτη, σε συνδυασμό με σημαντικό οικονομικό όφελος.`,
            bar0Label: "ασφαλης φυλαξη αρχειων",
            bar1Label: "ασφαλης ψηφιοποιηση φυσικων αρχειων",
            bar2Label: "ασφαλης διαχειριση αρχειων",
            bar3Label: "ασφαλης καταστροφη",
          },
          contactUsBtn: "επικοινωνηστε μαζι μας",
          servicesSession: {
            title: "Οι υπηρεσίες μας",
            subtitle: "Ασφαλής Φύλαξη Αρχείων",
            li0: "Εξωτερική φύλαξη φυσικού εγγράφου και αρχείου",
            li1: "Φύλαξη αρχείων σε περιβάλλον κλιματικά ελεγχόμενο",
            li2: "Οργάνωση των αρχείων σας σε ελεγχόμενο απόθεμα",
          },
          ourServicesBtn: "οι υπηρεσιες μας",
        },
        services: {
          title: "οι υπηρεσίες μας",
        },
        gdpr: {
          title: "Ασφαλής Διαχείριση Πληροφοριών και Συμμόρφωσης GDPR",
          session0: {
            title: "Τι σημαίνει για τον Οργανισμό / Εταιρεία σας;",
            description:
              "Το GDPR ισχύει για οποιονδήποτε Οργανισμό εντός ή εκτός της Ευρωπαϊκής Ένωσης που εμπορεύεται αγαθά ή υπηρεσίες ή / και παρακολουθεί τις συμπεριφορές των πολιτών της ΕΕ. Αυτό σημαίνει ότι εάν συνεργάζεστε με Ευρωπαίους το οποίο περιλαμβάνει την επεξεργασία των προσωπικών τους δεδομένων, τότε αυτή η νομοθεσία ισχύει για εσάς.",
          },
          session1: {
            title: "Βασικές Προκλήσεις",
            description:
              "Ο νέος κανονισμός επηρεάζει τις επιχειρήσεις με πολλούς τρόπους. Το απόρρητο και η προστασία δεδομένων αποτελούν μέρος των βασικών απαιτήσεων μιας εταιρείας που οδηγούν στη συλλογή και αποθήκευση δεδομένων. Όλοι οι οργανισμοί πρέπει να προετοιμαστούν και να συμμορφωθούν σωστά με τις νέες πολιτικές, διαφορετικά μπορεί να τους επιβληθεί πρόστιμο. Αυτός ο κανονισμός ισχύει τόσο για τους ελεγκτές δεδομένων όσο και για τους επεξεργαστές αυτών.",
          },
          servicesTitle:
            "Η The Records Hub S.A. σας παρέχει εξατομικευμένες υπηρεσίες συμμόρφωσης, υλοποίησης, εκπαίδευσης και υποστήριξης οι οποίες καλύπτουν όλο το φάσμα του GDPR.",
        },
        ourProjects: {
          title: "Τα έργα μας",
          numberLabel0: "ολοκληρωμενα εργα",
          numberLabel1: "πελατες",
        },
        contactUs: {
          title: "Επικοινωνήστε Μαζί μας",
        },
        cookies: {
          description:
            "Αυτή η ιστοσελίδα αποθηκεύει μόνο τα απαραίτητα cookies για να διασφαλίσει τη σωστή λειτουργία της. Δεν συλλέγουμε προσωπικές πληροφορίες , διασφαλίζοντας την ιδιωτικότητά σας.",
          closeBtn: "Κατάλαβα",
        },
      },
    },
  },
});

export default i18n;
